/*!

=========================================================
* 　テンプレート
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";

import InputText from '../FormParts/InputText'
import InputRadio from '../FormParts/InputRadio'
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import {
  cst_reminder_sms_flag,
  cst_customer_user_reminder_send_flag,
  cst_notification_flag
} from '../../variables/codes_map';
import WithRole from '../FormParts/ButtonWithRole';
import Request from '../../common/Request';
import { getErrorCodes,GetMessage } from "../../variables/message";
import OpenFaxModal from '../FormParts/OpenFaxModal'
import InputCheckBox from "../FormParts/InputCheckBox";
import ApprovedInfo from '../ViewParts/ApprovedInfo';

const domain = "";

class BranchRegist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      valid: true,
      regist_modal: false,
      branch_regist_modal: false,
      error_modal: false,
      customer_id:"",
      customer: [],
      customer_branch: [],
      original_email:"",
      data: {
        values:{
          notification_flag: cst_notification_flag[0].default,
          customer_reminder_sms_flag : cst_reminder_sms_flag[0].default,
          customer_user_reminder_send_flag : cst_customer_user_reminder_send_flag[0].default,
          customer_user_name: ""
        },
        errors:{},
        requiredData:{},
      },
      view: false
    };
    
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleClientRegistModal = this.toggleClientRegistModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this)
    this.checkEmail = this.checkEmail.bind(this)

    
  }

  // 初期ロード用
  componentDidMount() {
    /*　ここは開発者が記述　*/
    //:customer_user_idは更新
    //:customer_branch_idは追加
    if(this.props.match.params.customer_branch_id != undefined){
      const url = domain + '/api/customer/branch/'+this.props.match.params.customer_branch_id;
      Request.get(url, {},res => {
        console.log(res.Data);
        if(res.Data.customer_id){
          this.setState({
            data:{
              ...this.state.data,
              values:{
                ...this.state.data.values,
                ...res.Data,
                customer_branch_ulid: res.Data.ulid,
                // notification_flag:res.Data.customer_system_use_flag == "1" && res.Data.c_customer_system_use_flag == "1" ? "0" :"1",
                notification_flag: "0",
                customer_reminder_sms_flag:"1",
              },
            },
            view:false            
          }, ()=>{
            this.setRequiredData()
            this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
          });
        }else{
          this.props.alertModal.current.showErrorModal({messageNo:2404});
        }
      });
    }else if(this.props.match.params.customer_user_id != undefined){
      const url = domain + '/api/customer/user/'+this.props.match.params.customer_user_id;
      Request.get(url,{},res => {
        this.setState({
          original_email:res.Data.customer_user_email,
          data:{
              ...this.state.data,
              values: {
                ...res.Data,
                notification_flag:res.Data.notification_flag,
                customer_reminder_sms_flag:res.Data.customer_reminder_sms_flag,
              },
          },
          view:true
        });
        var url = domain + '/api/landmark/lastupdate/' + res.Data.lastupdate_user_id;
        var params = {};
        Request.get(url, params, res => {
          this.setState({
            data:{
              ...this.state.data,
              values:{
                ...this.state.data.values,
                lastupdate_user:res.Data
              }
            }
          }, ()=>{
            this.setRequiredData()
            this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
          })
        });
      });
    }
    // スクロールバーを表示するように設定
    document.body.style.overflow = "auto";
  }

  setRequiredData = async ()=>{
    const url = domain + '/api/customer/user';
    const requiredCheckedData = await Request.getRequiredData(url, this.state.data)

    this.setState({
      data:{
        ...requiredCheckedData,
      }
    })
  }

  async checkEmail(email){
    let post_email = encodeURIComponent(email);
    // console.log(post_email);
    const url = domain + '/api/customer/user/check_mail?email='+post_email + '&customer_natural_id='+this.state.data.values.customer_natural_id;
    Request.get(url,{},res => {
      let check = true;
      if(res.Data == "NG"){
        check = false;
      }
      this.setState({
        data:{
          ...this.state.data,
          errors:{...this.state.data.errors,
            customer_user_email:check == false ? [GetMessage(2604)] : this.state.data.errors.customer_user_email
          } 
        }
      })

    });
  }

  validate() {
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    const data = this.state.data;
    // console.log(newData.values.customer_user_email,this.state.original_email)
    let mail_check = true;
    if(data.values && newData.values.customer_user_email != "" && newData.values.customer_user_email != this.state.original_email){
      // console.log(newData.values.customer_user_email)
      this.checkEmail(newData.values.customer_user_email);
    }
    // if(newData.values.notification_flag == "1" && data.values.customer_reminder_sms_flag == "1"){
    //   newData.values.customer_reminder_sms_flag = "0"
    // }
    // if(newData.values.customer_reminder_sms_flag == "1" && data.values.notification_flag == "1"){
    //   newData.values.notification_flag = "0"
    // }

    // console.log(mail_check)
    this.setState({
      data:{
        ...data,
        ...newData,
      }
    }, ()=>callback())
  }

  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }
  toggleClientRegistModal(){
    if(this.props.match.params.customer_id != undefined){
      return null;
    }else{
      this.setState({
        client_regist_modal: !this.state.client_regist_modal
      });
    }
  }

  regist() {
    // TODO 登録API呼び出し
    const url = domain + '/api/customer/user';
    const params = {
      ...this.state.data.values,
      customer_ulid: this.state.data.values.customer_ulid,
      customer_branch_ulid: this.state.data.values.customer_branch_ulid
    }
    if(this.state.view === false) {
      console.log(params);
      Request.post(url, params, res => {
        console.log(res.Data);
        if(res.Data.ulid){
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push('/customer?customer_natural_id='+this.state.data.values.customer_natural_id
            +'&customer_branch_natural_id='+this.state.data.values.customer_branch_natural_id
            +'&customer_user_natural_id='+res.Data.customer_user_natural_id
          )
        }else{
          const messageObj = (res.Code>=800)
            ?{messageNo:[2402,...(res.Data.length?res.Data.map(error=>error[0]):[res.Data.error])]}
            :{messageNo:2402}
          this.props.alertModal.current.showErrorModal(messageObj);
        }
      });
    } else {
      Request.put(url + "/" + this.props.match.params.customer_user_id, params, res => {
        console.log(res.Data);
        if(res.Data.ulid){
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push(`/customer/detail/user/${this.props.match.params.customer_user_id}`) 
        }else{
          const messageObj = (res.Code>=800)
            ?{messageNo:[2403,...(res.Data.length?res.Data.map(error=>error[0]):[res.Data.error])]}
            :{messageNo:2403}
          this.props.alertModal.current.showErrorModal(messageObj);
        }
      });
    }
  }
  
  button_name(){
    if(this.state.view === false){
      return "登録";
    }else{
      return "更新";
    }
  }

  set_title(){
    if(this.state.view === false){
      return "新規担当者追加";
    }
    return "担当者情報更新";
  }
  render() {
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
    const employeeType = parseInt(localStorage.employee_type)
    console.log(this.state.data)
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3">{this.set_title()}</CardTitle>
                </CardHeader>
                <Col md="11" className="detail">
                <ApprovedInfo
                  rootData={this.state.data}
                  validateCallback={this.validateCallback}
                  employeeType={employeeType}
                  visible={this.state.view}
                  isEdit={true}
                /> 
                <SystemInfo
                        id_title='支店ID'
                        id_value={this.state.data.values.customer_user_natural_id}
                        update_timestamp={this.state.data.values.update_timestamp}
                        update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                        update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                        visible={this.state.view} /> 

                  <CardTitle tag="h4">管理情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th>管理情報</th> */}
                        <CustomTd label='メモ'
                            name='CUSTOMER_USER__system_memo'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText multiline={true}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      {this.state.view === true && 
                        <tr>
                          <CustomTd label='削除フラグ'
                            name='CUSTOMER_USER__delete_flag'
                            copy={false}
                            value={
                              <InputCheckBox 
                                validateCallback={this.validateCallback} 
                                checkedValue={1}
                                uncheckedValue={0}
                                rootData={this.state.data}
                              />
                            }
                          />
                        </tr>
                      }
                    </tbody>
                  </Table>                           
                  <CardTitle tag="h4">基本情報</CardTitle>
                  <Table>
                    <tbody>
                    <tr>
                          {/* <th rowSpan="2">会社情報</th> */}
                          <CustomTd label='会社名'
                            name='CUSTOMER__customer_name'
                            copy={false}
                            data={this.state.data.values}
                            hasKanaInput={true}
                          />
                        </tr>                       
                        <tr>
                          <CustomTd label='会社名（カナ）'
                            name='CUSTOMER__customer_name_kana'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          {/* <th rowSpan="4">支店情報</th> */}
                          <CustomTd label='支店名'
                            name='CUSTOMER_BRANCH__customer_branch_name'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          <CustomTd label='支店名（カナ）'
                            name='CUSTOMER_BRANCH__customer_branch_name_kana'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          <CustomTd label='電話番号'
                            name='CUSTOMER_BRANCH__customer_branch_tel'
                            copy={true}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          <CustomTd label='FAX番号'
                            name='CUSTOMER_BRANCH__customer_branch_fax'
                            value={
                              <OpenFaxModal
                                data={this.state.data.values}
                                onClick={()=>this.props.faxModal.current.setFaxModal({
                                  fax_recipient_name:this.state.data.values.customer_name
                                    +"\n"+this.state.data.values.customer_branch_name
                                    +(this.state.data.values.customer_user_name!= ""?"\n"+this.state.data.values.customer_user_name:"")+" 御中",
                                  fax_recipient_number:this.state.data.values.customer_branch_fax
                                })}
                              />
                            }
                          />
                        </tr>

                        <tr>
                          {/* <th rowSpan="6">担当者情報</th> */}
                          <CustomTd label='担当者名'
                            name='CUSTOMER_USER__customer_user_name'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                hasKanaInput={true}
                              />
                            }
                          />
                        </tr>                       
                        <tr>
                          <CustomTd label='担当者名（カナ）'
                            name='CUSTOMER_USER__customer_user_name_kana'
                            copy={false}
                            rootData={this.state.data}
                            value={
                                <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='担当者部署名'
                            name='CUSTOMER_USER__customer_user_division_name'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='携帯電話番号'
                            name='CUSTOMER_USER__customer_user_tel'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='固定電話番号'
                            name='CUSTOMER_USER__customer_user_tel2'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                        <CustomTd label='リマインド送信有無'
                            name='CUSTOMER_USER__customer_user_reminder_send_flag'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                options={cst_customer_user_reminder_send_flag}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                        </tr>
                        <tr>
                          <CustomTd label='SMSリマインド送信有無'
                            name='CUSTOMER_USER__customer_reminder_sms_flag'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                options={cst_reminder_sms_flag}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                disabled={this.state.data.values.customer_system_use_flag == "1" && this.state.data.values.c_customer_system_use_flag == "1" }
                                description={"※携帯電話番号が空欄の場合、SMSは送信されません"}
                              />
                            }
                          />
                        </tr>
                        {this.state.data.values.customer_system_use_flag == "1" && this.state.data.values.c_customer_system_use_flag == "1" ? (
                        <tr>
                          <CustomTd label='PUSH通知送信有無'
                            name='CUSTOMER_USER__notification_flag'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                options={cst_notification_flag}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                disabled={true}
                                description={""}
                              />
                            }
                          />
                        </tr>
                        ):""}
                        <tr>
                          <CustomTd label='メールアドレス'
                            name='CUSTOMER_USER__customer_user_email'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                          /> 
                        </tr>
                    </tbody>
                  </Table>
                  <Row md="12">
                    <Col md="4" className="text-center">
                      <Button color="secondary" onClick={() => { 
                        if(this.state.view === false){
                          this.props.history.push('/customer') 
                        } else {
                          this.props.history.push(`/customer/detail/user/${this.props.match.params.customer_user_id}`) 
                        }
                      }}>キャンセル</Button>
                    </Col>
                    <Col md="4" className="text-center">
                      <ButtonWithRole
                        button_id={this.state.view?"BTN_M1_10_04170":"BTN_M1_04_03950"}
                        color="info" 
                        onClick={() => {
                          if(this.validate()){
                            this.toggleRegistModal()
                          }
                        }}
                      >{this.button_name()}
                      </ButtonWithRole>
                    </Col>
                  </Row>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>{this.button_name()}しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole
              button_id={this.state.view?"BTN_M1_10_04190":"BTN_M1_04_03970"} 
              color="info" onClick={() => {this.toggleRegistModal(); this.regist();}}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default BranchRegist;
